import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash/lang';
import globalMessages from 'containers/App/messages';
import {
  getMinCurrencyValue,
  getMaxCurrencyValue,
  getMinCurrencyValueMonthly,
} from 'containers/IwaIllustrationPage/helper';
import { PAYMENT_TERM_SINGLE_LUMP_SUMP, PAYMENT_TERM_MONTHLY } from 'containers/IwaIllustrationPage/constants'

const validate = (values, props) => {
  const errors = {};
  const { iwaConfig } = props;

  const MAX_GROWTH_RATE = iwaConfig?.features?.growthRate?.maxRate;
  const MIN_GROWTH_RATE = iwaConfig?.features?.growthRate?.minRate;
  const MAX_TARGET_FUND = 999999999;
  const MAX_TARGE_YEAR = 2100;

  if (!values.isEmpty()) {
    const offerCodeValues = values.get('offerCode');
    const startDateValues = values.get('startDate');
    const currencyValues = values.get('currency');
    const premiumPaymentTermValues = values.get('premiumPaymentTerm');
    const growthRateValues = values.get('growthRate');
    const premiumValues = values.get('premium');
    const singlePremiumAmountValues = values.get('singlePremiumAmount');
    const targetFunctionalityValues = values.get('targetFunctionality');
    const hasToCalculate = values.get('hasToCalculate');
    const targetYearValues = values.get('targetYear');
    const targetFundValues = values.get('targetFund');
    const isAdditionalSinglePremium = values.get('isAdditionalSinglePremium');
    const isRegularWithdrawalValues = values.get('isRegularWithdrawal');
    const regularWithdrawalValues = values.get('regularWithdrawal');
    // const additionalSinglePremiumValues = values.get('additionalSinglePremium');
    const isChargeBasis = values.get('isChargeBasis');

    if (!startDateValues || !moment(startDateValues).isValid())
      errors.startDate = (
        <FormattedMessage {...globalMessages.pleaseSelectValue} />
      );

   
    if (!currencyValues || currencyValues === 'Select')
      errors.currency = (
        <FormattedMessage {...globalMessages.pleaseSelectValue} />
    );

    if (!premiumPaymentTermValues || premiumPaymentTermValues === 'Select')
    errors.premiumPaymentTerm = (
      <FormattedMessage {...globalMessages.pleaseSelectValue} />
    );

    if (targetFunctionalityValues) {
      if (!targetYearValues || targetYearValues === 'Invalid date')
        errors.targetYear = (
          <FormattedMessage {...globalMessages.pleaseEnterValue} />
        );
      else if (
        targetYearValues &&
        targetYearValues < new Date().getFullYear() + 5
      )
        errors.targetYear = (
          <FormattedMessage
            {...globalMessages.minLimit}
            values={{ value: new Date().getFullYear() + 5 }}
          />
        );
      else if (targetYearValues && targetYearValues > MAX_TARGE_YEAR)
        errors.targetYear = (
          <FormattedMessage
            {...globalMessages.maxLimit}
            values={{ value: MAX_TARGE_YEAR }}
          />
        );

      if (!targetFundValues)
        errors.targetFund = (
          <FormattedMessage {...globalMessages.pleaseEnterValue} />
        );
      else if (targetFundValues && targetFundValues <= 0)
        errors.targetFund = (
          <FormattedMessage {...globalMessages.greaterThanZero} />
        );
      else if (targetFundValues > MAX_TARGET_FUND) {
        errors.targetFund = (
          <FormattedMessage
            {...globalMessages.maxLimit}
            values={{
              value: MAX_TARGET_FUND.toString().replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ',',
              ),
            }}
          />
        );
      }
    }

    if (hasToCalculate) {
      errors.hasToCalculate = (
        <FormattedMessage {...globalMessages.hasToCalculate} />
      );
    }

    if (!Number(premiumValues)) {
      if (!targetFunctionalityValues)
        errors.premium = (
          <FormattedMessage {...globalMessages.pleaseEnterValue} />
        );
    } else {
      let minVal = 0;
      let maxVal = 0;

      if (premiumPaymentTermValues != 'Select' && premiumPaymentTermValues == PAYMENT_TERM_SINGLE_LUMP_SUMP) {
        minVal = getMinCurrencyValue(currencyValues, iwaConfig.features);
      } else  if (premiumPaymentTermValues != 'Select' && premiumPaymentTermValues == PAYMENT_TERM_MONTHLY) {
        minVal = getMinCurrencyValueMonthly(currencyValues, iwaConfig.features);
      }
      maxVal = getMaxCurrencyValue(currencyValues, iwaConfig.features);

      if (premiumValues < minVal) {
        if (premiumPaymentTermValues != 'Select' && minVal != 0) {

              errors.premium = (
                <FormattedMessage
                  {...globalMessages.minLimit}
                  values={{ value: minVal }}
                />
              );

       } else if (premiumPaymentTermValues == 'Select') {
              errors.premium = (
                <FormattedMessage
                  {...globalMessages.minLimit}
                  values={{ value: minVal }}
                />
              );
       }
      }
      if (premiumPaymentTermValues == PAYMENT_TERM_SINGLE_LUMP_SUMP && premiumValues > maxVal) {
        errors.premium = (
          <FormattedMessage
            {...globalMessages.maxLimit}
            values={{ value: maxVal }}
          />
        );
      } else if (premiumPaymentTermValues == PAYMENT_TERM_MONTHLY && singlePremiumAmountValues > maxVal){
        errors.singlePremiumAmount = (
          <FormattedMessage
            {...globalMessages.maxLimit}
            values={{ value: maxVal }}
          />
        );
      }
    }

    if (!growthRateValues)
      errors.growthRate = (
        <FormattedMessage {...globalMessages.pleaseEnterValue} />
      );
    else {
      if (growthRateValues <= MIN_GROWTH_RATE)
        errors.growthRate = (
          <FormattedMessage {...globalMessages.minLimitGrowthRate} />
        );
      if (growthRateValues > MAX_GROWTH_RATE)
        errors.growthRate = (
          <FormattedMessage
            {...globalMessages.maxLimit}
            values={{ value: MAX_GROWTH_RATE }}
          />
        );
    }

    // Regular withdrawal validation
    if (isRegularWithdrawalValues) {
      const errorRegularWithdrawal = {};
      if (
        !regularWithdrawalValues.get('frequency') ||
        regularWithdrawalValues.get('frequency') === 'Select'
      )
        errorRegularWithdrawal.frequency = (
          <FormattedMessage {...globalMessages.pleaseSelectValue} />
        );

      if (
        !regularWithdrawalValues.get('startDate') ||
        !moment(regularWithdrawalValues.get('startDate')).isValid()
      )
        errorRegularWithdrawal.startDate = (
          <FormattedMessage {...globalMessages.enterValidValue} />
        );
      else {
        var regularStartDateValues = moment(
          regularWithdrawalValues.get('startDate'),
        );
        // const minStartDate = moment(startDateValues)
        //   .date(15)
        //   .add(1, 'months')
        //   .toDate();

        // IWA - 3 years validation on IWA coverage screen
        const minStartYear = moment(startDateValues)
          .date(15)
          .add(3, 'years')
          .toDate();

        if (moment(regularStartDateValues, 'YYYY-MM-DD').format('DD') != 15)
          errorRegularWithdrawal.startDate = (
            <FormattedMessage {...globalMessages.dateValidation2} />
          );
        else if (regularStartDateValues.isBefore(minStartYear)) // IWA - 3 years validation
          errorRegularWithdrawal.startDate = (
            <FormattedMessage
              {...globalMessages.dateValidation}
              values={{ value: moment(minStartYear).format('DD/MM/YYYY') }} // IWA - 3 years validation
            />
          );
      }

      if (
        !regularWithdrawalValues.get('endDate') ||
        !moment(regularWithdrawalValues.get('endDate')).isValid()
      )
        errorRegularWithdrawal.endDate = (
          <FormattedMessage {...globalMessages.enterValidValue} />
        );
      else {
        const regularEndDateValue = moment(
          regularWithdrawalValues.get('endDate'),
        );
        var regularStartDateValues = moment(
          regularWithdrawalValues.get('startDate'),
        );
        const maxEndDate = moment(regularStartDateValues)
          .add(100, 'years')
          .toDate();

        if (regularEndDateValue.isBefore(regularStartDateValues))
          errorRegularWithdrawal.endDate = (
            <FormattedMessage {...globalMessages.minEndDateValidation} />
          );

        if (regularEndDateValue.isAfter(maxEndDate))
          errorRegularWithdrawal.endDate = (
            <FormattedMessage {...globalMessages.maxEndDateValidation} />
          );
      }

      if (regularWithdrawalValues.get('isAmountChecked') == 1) {
        if (!regularWithdrawalValues.get('amount'))
          errorRegularWithdrawal.amount = (
            <FormattedMessage {...globalMessages.pleaseEnterValue} />
          );
        else {
          const withdrawalAmount = Number(
            regularWithdrawalValues.get('amount'),
          );
          var minPremiumAllowed = 0;
          var maxPremiumAllowed = 0;

          iwaConfig.features.withdrawalSize.map(premiumSize => {
            if (premiumSize.currency === currencyValues) {
              minPremiumAllowed = premiumSize.minimumWithdrawalAmount;
              // maxPremiumAllowed = premiumSize.maxPremiumSingle;
            }
          });

          maxPremiumAllowed = getMaxCurrencyValue(
            currencyValues,
            iwaConfig.features,
          );

          if (withdrawalAmount < minPremiumAllowed)
            errorRegularWithdrawal.amount = (
              <FormattedMessage
                {...globalMessages.minWithdrawalValidation}
                values={{ value: minPremiumAllowed }}
              />
            );

          if (withdrawalAmount > maxPremiumAllowed)
            errorRegularWithdrawal.amount = (
              <FormattedMessage
                {...globalMessages.maxWithdrawalValidation}
                values={{ value: maxPremiumAllowed }}
              />
            );
        }
      }

      if (regularWithdrawalValues.get('isAmountChecked') == 2) {
        const minPercentage =
          iwaConfig.features?.regularWithdrawal?.minPercentage;
        const maxPercentage =
          iwaConfig.features?.regularWithdrawal?.maxPercentage;

        if (!regularWithdrawalValues.get('percentage'))
          errorRegularWithdrawal.percentage = (
            <FormattedMessage {...globalMessages.pleaseEnterValue} />
          );
        else {
          if (regularWithdrawalValues.get('percentage') <= 0)
            errorRegularWithdrawal.percentage = (
              <FormattedMessage
                {...globalMessages.minWithdrawalValidation}
                values={{ value: minPercentage }}
              />
            );

          if (regularWithdrawalValues.get('percentage') > maxPercentage)
            errorRegularWithdrawal.percentage = (
              <FormattedMessage
                {...globalMessages.maxWithdrawalValidation}
                values={{ value: maxPercentage }}
              />
            );
        }
      }
      if (!isEmpty(errorRegularWithdrawal)) {
        errors.regularWithdrawal = errorRegularWithdrawal;
      }
    }
    // if (!isChargeBasis) {
    //   errors.isChargeBasis = 'Please select any one charge' 
    // }

    // Education Fee withdrawal validation
    // if (isAdditionalSinglePremium) {
    //   const errorAdditionalSinglePremium = {};
    //   if (
    //     !additionalSinglePremiumValues.get('frequency') ||
    //     additionalSinglePremiumValues.get('frequency') === 'Select'
    //   )
    //     errorAdditionalSinglePremium.frequency = (
    //       <FormattedMessage {...globalMessages.pleaseSelectValue} />
    //     );
    //   if (!additionalSinglePremiumValues.get('amount'))
    //     errorAdditionalSinglePremium.amount = (
    //       <FormattedMessage {...globalMessages.pleaseEnterValue} />
    //     );
    //   else {
    //     const withdrawalAmount = Number(
    //       additionalSinglePremiumValues.get('amount'),
    //     );
    //     var minPremiumAllowed = 0;
    //     var maxPremiumAllowed = 0;

    //     iwaConfig.features.currencyPremiumSize.map(premiumSize => {
    //       if (premiumSize.currency === currencyValues) {
    //         minPremiumAllowed = premiumSize.minAdditionalSinglePremium;
    //         maxPremiumAllowed = premiumSize.maxAdditionalSinglePremium;
    //       }
    //     });

    //     // maxPremiumAllowed = getMaxValue(paymentFrequencyValues, iwaConfig.features, currencyValues);

    //     if (withdrawalAmount < minPremiumAllowed)
    //       errorAdditionalSinglePremium.amount = (
    //         <FormattedMessage
    //           {...globalMessages.minWithdrawalValidation}
    //           values={{ value: minPremiumAllowed }}
    //         />
    //       );

    //     if (withdrawalAmount > maxPremiumAllowed)
    //       errorAdditionalSinglePremium.amount = (
    //         <FormattedMessage
    //           {...globalMessages.maxWithdrawalValidation}
    //           values={{ value: maxPremiumAllowed }}
    //         />
    //       );
    //   }

    //   if (!isEmpty(errorAdditionalSinglePremium)) {
    //     errors.additionalSinglePremium = errorAdditionalSinglePremium;
    //   }
    // }



    if (!isEmpty(offerCodeValues)) {
      if (premiumValues === '') {
        errors.offerCode = (
          <FormattedMessage {...globalMessages.pleaseFillInThePremium} />
        );
      }
      if (currencyValues === 'Select') {
        errors.offerCode = (
          <FormattedMessage {...globalMessages.pleaseSelectCurrency} />
        );
      }
    }
  }
  console.log("errors :: ", errors);
  return errors;
};

export default validate;
